import { reset } from 'src/store'

const loggedInStates = () => {
  return [
    'articles'
  ]
}

const defaultStates = () => {
  return {
    articles: []
  }
}

export default {
  namespaced: true,
  state: defaultStates(),
  mutations: {
    reset (state) {
      reset(state, loggedInStates(), defaultStates())
    },
    setArticles (state, articles) {
      state.articles = articles
    }
  },
  getters: {
    getArticles: state => state.articles
  }
}
